import React from 'react';

import { useNavigate } from 'react-router-dom';

import { AreaPageContext } from '@app/components/Pages/Area/Area';
import PhoneSVG from '@app/images/PhoneSVG';
import { Area } from '@app/objects/Area';
import { BOOKING } from '@app/utils/booking';

const AreaHeader: React.FC<{ area: Area | undefined }> = ({ area }) => {
	const navigate = useNavigate();
	const currentAreaUrl = React.useContext(AreaPageContext);

	const openForm = () => {
		if (area?.onlineBookingEnabled) {
			navigate(BOOKING);
		} else {
			navigate(`${currentAreaUrl}/request-info`);
		}
	};

	return area ? (
		<header className="area__header">
			<h1 className="area__title">{area.name}</h1>
			<section className="area__btns">
				<button className="btn btn-primary area__btn-wide" type="button" title="Schedule Appointment" onClick={openForm}>
					Schedule Appointment
				</button>
				<a className="btn btn-secondary" title="Request more info" type="button" href={`tel:${area.phoneNumber}`}>
					<PhoneSVG />
					{area.phoneNumber}
				</a>
				{area.secondPhoneNumber && (
					<a className="btn btn-secondary" type="button" title="Request more info" href={`tel:${area.secondPhoneNumber}`}>
						<PhoneSVG />
						{area.secondPhoneNumber}
					</a>
				)}
			</section>
		</header>
	) : null;
};

export default AreaHeader;
